module.exports = __webpack_public_path__ + "img/circle1Green.a2f1e40b.svg";